module.exports = __webpack_public_path__ + "assets/media/plus-about.31f24702.svg";